
// Function to check if state matches all conditions
const matchesConditions = (compareConditions, profileConditions) => {
    if (profileConditions?.conditions) {
        return Object.entries(profileConditions.conditions).every(([conditionName, expectedValue]) => Boolean(compareConditions[conditionName]) === expectedValue)
    }
    return false;
};


// Main function to get profile considering priority
export const getProfileByPriority = (compareConditions, profilesWithPriority) => {
    const getMatchingProfile = Object.values(profilesWithPriority)
        .sort((a, b) => (a?.priority || 0) - (b?.priority || 0))
        .find(profile => matchesConditions(compareConditions, profile))
    return getMatchingProfile ?? null;
};
